export var palette = {
    mode: 'light',
    common: {
        black: '#000000',
        white: '#FFFFFF',
    },
    primary: {
        A700: '#2E2E31',
        A400: '#87878F',
        A200: '#BEC0C9',
        A100: '#D1D2D9',
        900: '#0011c0',
        800: '#0022d9',
        700: '#002fe3',
        600: '#003bf0',
        500: '#0144fc',
        400: '#2763EA',
        300: '#6280ff',
        200: '#96a4fe',
        100: '#c2c8fe',
        50: '#e7e9ff',
        main: '#2763EA',
        light: '#6280ff',
        dark: '#0011c0',
        contrastText: '#ffffff',
    },
    secondary: {
        900: '#04060f',
        800: '#11193f',
        700: '#1b2856',
        600: '#2a396d',
        500: '#304075',
        400: '#4d5a87',
        300: '#6b769a',
        200: '#939bb7',
        100: '#bdc2d4',
        50: '#e5e7ed',
        main: '#1b2856',
        light: '#304075',
        dark: '#04060f',
        contrastText: '#ffffff',
    },
    grey: {
        900: '#171717',
        800: '#373737',
        700: '#555555',
        600: '#686868',
        500: '#999999',
        400: '#b0b0b0',
        300: '#d5d5d5',
        200: '#f2f2f2',
        100: '#F8F8F8',
        50: '#fcfcfc',
        main: '#686868',
        light: '#f2f2f2',
        dark: '#171717',
        contrastText: '#ffffff',
    },
    greySecondary: {
        A700: '#172967',
        A400: '#334ca5',
        A200: '#7085d0',
        A100: '#c9d4f4',
        900: '#2B2B31',
        800: '#3c3d4f',
        700: '#5b5b6f',
        600: '#6f6f83',
        500: '#83839A',
        400: '#9898ad',
        300: '#B6B6CA',
        200: '#D0D0DF',
        100: '#DFDFEE',
        50: '#e7e7f2',
        main: '#3c3d4f',
        light: '#B6B6CA',
        dark: '#2B2B31',
        contrastText: '#ffffff',
    },
    success: {
        900: '#005800',
        800: '#0f7600',
        700: '#218701',
        600: '#2f9812',
        500: '#39a71c',
        400: '#59b445',
        300: '#78c167',
        200: '#9fd193',
        100: '#c5e3bd',
        50: '#e7f4e4',
        main: '#2f9812',
        light: '#39a71c',
        dark: '#005800',
        contrastText: '#ffffff',
    },
    warning: {
        900: '#e65400',
        800: '#ef6f00',
        700: '#f57f00',
        600: '#fb8f01',
        500: '#ff9b02',
        400: '#ffa927',
        300: '#ffb94e',
        200: '#ffcd81',
        100: '#ffe1b3',
        50: '#fff3e0',
        main: '#f57f00',
        light: '#ff9b02',
        dark: '#e65400',
        contrastText: '#ffffff',
    },
    error: {
        900: '#c82b06',
        800: '#e13a11',
        700: '#ef4116',
        600: '#fd491b',
        500: '#ff4f20',
        400: '#FF6B41',
        300: '#ff8764',
        200: '#ffaa90',
        100: '#ffcbbc',
        50: '#fde9e7',
        main: '#ef4116',
        light: '#ff4f20',
        dark: '#c82b06',
        contrastText: '#ffffff',
    },
    info: {
        900: '#1532ad',
        800: '#213db9',
        700: '#1c5dd8',
        600: '#1670eb',
        500: '#0783ff',
        400: '#0091ff',
        300: '#58b3ff',
        200: '#8cc8ff',
        100: '#baddff',
        50: '#e2f2ff',
        main: '#1c5dd8',
        light: '#0783ff',
        dark: '#1532ad',
        contrastText: '#ffffff',
    },
    text: {
        primary: '#3c3d4f',
        secondary: '#6f6f83',
        disabled: '#B1B5BA',
    },
    divider: '#dfdfee',
    background: {
        default: '#fff',
        paper: '#FFFFFF',
    },
    action: {
        active: 'rgba(0, 0, 0, 0.54)',
        hover: 'rgba(0, 0, 0, 0.04)',
        hoverOpacity: 0.04,
        selected: 'rgba(0, 0, 0, 0.08)',
        selectedOpacity: 0.08,
        disabled: 'rgba(0, 0, 0, 0.26)',
        disabledBackground: 'rgba(0, 0, 0, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(0, 0, 0, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.12,
    },
};
//# sourceMappingURL=palette.js.map